import { consultationService } from '@/services/tmed-plans/consultation.service';

const state = {
  eligibility: null,
  balance: null,
  payments: null,
  cycles: null,
  paymentResult: null,
  eligibilityStatus: 'init',
  balanceStatus: 'init',
  paymentsStatus: 'init',
  cyclesStatus: 'init',
  paymentStatus: 'init',
  error: null,
};

const getters = {
  getEligibility: (state) => state.eligibility,
  getBalance: (state) => state.balance,
  getPayments: (state) => state.payments,
  getCycles: (state) => state.cycles,
  getPaymentResult: (state) => state.paymentResult,
  getEligibilityStatus: (state) => state.eligibilityStatus,
  getBalanceStatus: (state) => state.balanceStatus,
  getPaymentsStatus: (state) => state.paymentsStatus,
  getCyclesStatus: (state) => state.cyclesStatus,
  getPaymentStatus: (state) => state.paymentStatus,
  getError: (state) => state.error,
};

const actions = {
  async getEligibility({ commit }, params) {
    try {
      commit('SET_ELIGIBILITY_STATUS', 'loading');
      const response = await consultationService.getEligibility(params);
      commit('SET_ELIGIBILITY', response);
      commit('SET_ELIGIBILITY_STATUS', 'init');
      return response;
    } catch (error) {
      commit('SET_ERROR', error?.response?.data?.message || 'Erro ao verificar elegibilidade');
      commit('SET_ELIGIBILITY_STATUS', 'init');
      throw error;
    }
  },

  async getBalance({ commit }, params) {
    try {
      commit('SET_BALANCE_STATUS', 'loading');
      const response = await consultationService.getBalance(params);
      commit('SET_BALANCE', response);
      commit('SET_BALANCE_STATUS', 'init');
      return response;
    } catch (error) {
      commit('SET_ERROR', error?.response?.data?.message || 'Erro ao buscar saldo');
      commit('SET_BALANCE_STATUS', 'init');
      throw error;
    }
  },

  async payAvulsa({ commit }, payload) {
    try {
      commit('SET_PAYMENT_STATUS', 'loading');
      const response = await consultationService.payAvulsa(payload);
      commit('SET_PAYMENT_RESULT', response);
      commit('SET_PAYMENT_STATUS', 'init');
      return response;
    } catch (error) {
      commit('SET_ERROR', error?.response?.data?.message || 'Erro ao processar pagamento');
      commit('SET_PAYMENT_STATUS', 'init');
      throw error;
    }
  },

  async getPayments({ commit }, params) {
    try {
      commit('SET_PAYMENTS_STATUS', 'loading');
      const response = await consultationService.getPayments(params);
      commit('SET_PAYMENTS', response);
      commit('SET_PAYMENTS_STATUS', 'init');
      return response;
    } catch (error) {
      commit('SET_ERROR', error?.response?.data?.message || 'Erro ao buscar pagamentos');
      commit('SET_PAYMENTS_STATUS', 'init');
      throw error;
    }
  },

  async getCycles({ commit }, params) {
    try {
      commit('SET_CYCLES_STATUS', 'loading');
      const response = await consultationService.getCycles(params);
      commit('SET_CYCLES', response);
      commit('SET_CYCLES_STATUS', 'init');
      return response;
    } catch (error) {
      commit('SET_ERROR', error?.response?.data?.message || 'Erro ao buscar histórico de ciclos');
      commit('SET_CYCLES_STATUS', 'init');
      throw error;
    }
  },

  clearConsultationState({ commit }) {
    commit('CLEAR_CONSULTATION_STATE');
  },
};

const mutations = {
  SET_ELIGIBILITY(state, eligibility) {
    state.eligibility = eligibility;
  },
  SET_BALANCE(state, balance) {
    state.balance = balance;
  },
  SET_PAYMENTS(state, payments) {
    state.payments = payments;
  },
  SET_CYCLES(state, cycles) {
    state.cycles = cycles;
  },
  SET_PAYMENT_RESULT(state, paymentResult) {
    state.paymentResult = paymentResult;
  },
  SET_ELIGIBILITY_STATUS(state, status) {
    state.eligibilityStatus = status;
  },
  SET_BALANCE_STATUS(state, status) {
    state.balanceStatus = status;
  },
  SET_PAYMENTS_STATUS(state, status) {
    state.paymentsStatus = status;
  },
  SET_CYCLES_STATUS(state, status) {
    state.cyclesStatus = status;
  },
  SET_PAYMENT_STATUS(state, status) {
    state.paymentStatus = status;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  CLEAR_CONSULTATION_STATE(state) {
    state.eligibility = null;
    state.balance = null;
    state.payments = null;
    state.cycles = null;
    state.paymentResult = null;
    state.error = null;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
